// extracted by mini-css-extract-plugin
export default {"image":"image__3ObB9","image__img":"image__img__10ejt","image__img_loading":"image__img_loading__1xZxz"};